import React from 'react';
import { Star, Quote, BadgeCheck } from 'lucide-react';
import { testimonials } from '../data/mock';
import { SectionHeading } from './Reveal';

const QuoteCard = ({ t }) => (
  <div className="lux-card w-[340px] sm:w-[420px] shrink-0 p-6 mx-3 flex flex-col" data-testid={`testimonial-card-${t.id}`}>
    <div className="flex items-center justify-between">
      <div className="flex gap-0.5">{[1,2,3,4,5].map(i => <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" />)}</div>
      <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-emerald-700"><BadgeCheck className="w-3.5 h-3.5" /> Verifiziert</span>
    </div>
    <p className="mt-4 text-slate-700 leading-relaxed text-sm sm:text-base">„{t.text}“</p>
  </div>
);

const Row = ({ items, reverse = false, duration = 60 }) => (
  <div className="relative overflow-hidden py-3">
    <div className="absolute left-0 inset-y-0 w-24 sm:w-40 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
    <div className="absolute right-0 inset-y-0 w-24 sm:w-40 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
    <div className="marquee-track" style={{ animationDuration: `${duration}s`, animationDirection: reverse ? 'reverse' : 'normal' }}>
      {[...items, ...items].map((t, i) => <QuoteCard key={`${t.id}-${i}`} t={t} />)}
    </div>
  </div>
);

const TestimonialsSection = () => {
  const half = Math.ceil(testimonials.length / 2);
  return (
    <section id="testimonials" className="relative bg-white py-24 lg:py-32 overflow-hidden" data-testid="testimonials-section">
      <div className="absolute -left-40 bottom-0 w-[500px] h-[500px] rounded-full bg-amber-100/60 blur-[140px] pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 mb-12">
        <SectionHeading
          eyebrow="Erfahrungen"
          title={<>Über 200 Unternehmen. <span className="text-violet-gradient">Eine Bewertung: 5.0.</span></>}
          subtitle="Was Geschäftsführer und HR-Leiter nach der Zusammenarbeit mit HIREKA sagen."
        />
        <div className="mt-8 flex justify-center">
          <div className="lux-card px-6 py-3 flex items-center gap-4" data-testid="testimonials-rating">
            <Quote className="w-5 h-5 text-amber-400" />
            <div className="flex gap-0.5">{[1,2,3,4,5].map(i => <Star key={i} className="w-5 h-5 text-amber-400 fill-amber-400" />)}</div>
            <div className="text-sm"><span className="font-bold text-slate-900">5.0</span> <span className="text-slate-500">aus 50+ Bewertungen</span></div>
          </div>
        </div>
      </div>

      <div className="relative space-y-2" data-testid="testimonials-marquee">
        <Row items={testimonials.slice(0, half)} duration={70} />
        <Row items={testimonials.slice(half)} reverse duration={80} />
      </div>
    </section>
  );
};

export default TestimonialsSection;
